import * as Link from "./link";
export { Link };



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/link/index.ts
// module id = NpMb
// module chunks = 2